import React from 'react';
import { Link } from 'react-router-dom';
import './WorkWithUs.css';

const JOB_DETAILS = {
  title: 'Intern / Tech & Operations Assistant',
  companies: ['Avika Ventures', 'Saat Saheli'],
  location: 'Remote',
  duration: '3 Months (Flexible start)',
  email: 'contact@avikaventures.com',
  about: [
    'We are looking for a hands-on Intern / Tech & Operations Assistant to work directly with founders on building real digital products from end to end.',
    'This is not a "coffee-fetching internship." This is a real startup building experience where you will work on: product development, coding & tech execution, user support & communication, and operations & platform management.',
    'You will contribute to two live projects: Avika Ventures — AI, startup building & software development studio, and Saat Saheli — Digital magazine & creative community platform.',
  ],
  responsibilities: [
    'Build & support real web applications',
    'Assist in frontend/backend development (based on skill)',
    'Help improve product features and user experience',
    'Work on platform updates and operations',
    'Talk to users and handle basic support queries',
    'Collect feedback and improve product flow',
    'Manage and monitor digital platforms',
    'Social media promotion & digital outreach',
    'Magazine editing and content coordination',
    'Podcast planning, recording support & editing',
  ],
  qualifications: [
    'Curious about startups, AI, and product building',
    'Comfortable with basic coding or eager to learn fast',
    'Good at communication and problem-solving',
    'Self-driven and responsible',
    'Excited to work on real-world systems',
    'Good communication skills in Hindi and English',
  ],
  bonusSkills: [
    'Spring Boot/ Java/ JavaScript / React',
    'Interest in AI tools or automation',
    'UI/UX understanding',
    'Content or community management',
  ],
  benefits: [
    'Real startup experience (not theoretical work)',
    'End-to-end product building exposure',
    'Direct mentorship from founders',
    'Hands-on experience in AI + SaaS + digital platforms',
    'Certificate + potential long-term opportunity',
    'Flexible remote work environment',
  ],
};

const WorkWithUs = () => {
  return (
    <div className="work-page">
      {/* Hero */}
      <section className="work-hero">
        <div className="section-container" style={{ textAlign: 'center' }}>
          <span className="section-label">We're Hiring</span>
          <h1 className="section-title" style={{ maxWidth: 800, margin: '0 auto 20px' }}>
            <span className="text-gradient">Work With Us</span>
          </h1>
          <p className="section-subtitle" style={{ margin: '0 auto', maxWidth: 700 }}>
            Join Avika Ventures and Saat Saheli in building real digital products used by real people.
          </p>
        </div>
      </section>

      {/* Job Overview */}
      <section className="section">
        <div className="section-container">
          <div className="job-header">
            <div className="job-header-top">
              <span className="job-badge">Open Position</span>
              <span className="job-badge job-badge-green">Remote</span>
            </div>
            <h2 className="job-title">{JOB_DETAILS.title}</h2>
            <div className="job-meta">
              <span>🏢 {JOB_DETAILS.companies.join(' + ')}</span>
              <span>📍 {JOB_DETAILS.location}</span>
              <span>⏳ {JOB_DETAILS.duration}</span>
            </div>
          </div>
        </div>
      </section>

      {/* About */}
      <section className="section" style={{ background: 'var(--bg-dark)' }}>
        <div className="section-container">
          <span className="section-label">About the Opportunity</span>
          <h2 className="section-title" style={{ fontSize: '2rem' }}>What This Is</h2>
          <div className="work-content">
            {JOB_DETAILS.about.map((p, i) => (
              <p key={i} className="work-paragraph">{p}</p>
            ))}
          </div>
        </div>
      </section>

      {/* Responsibilities */}
      <section className="section">
        <div className="section-container">
          <span className="section-label">What You'll Do</span>
          <h2 className="section-title" style={{ fontSize: '2rem' }}>Responsibilities</h2>
          <div className="work-list-grid">
            {JOB_DETAILS.responsibilities.map((item, i) => (
              <div key={i} className="work-list-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#06b6d4" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Qualifications */}
      <section className="section" style={{ background: 'var(--bg-dark)' }}>
        <div className="section-container">
          <div className="work-two-col">
            <div>
              <span className="section-label">Who We're Looking For</span>
              <h2 className="section-title" style={{ fontSize: '2rem' }}>Qualifications</h2>
              <div className="work-list-grid">
                {JOB_DETAILS.qualifications.map((item, i) => (
                  <div key={i} className="work-list-item">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#06b6d4" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <span className="section-label">Bonus Skills</span>
              <h2 className="section-title" style={{ fontSize: '2rem' }}>Nice to Have</h2>
              <div className="work-list-grid">
                {JOB_DETAILS.bonusSkills.map((item, i) => (
                  <div key={i} className="work-list-item">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="section">
        <div className="section-container">
          <span className="section-label">What You'll Gain</span>
          <h2 className="section-title" style={{ fontSize: '2rem' }}>Benefits</h2>
          <div className="work-list-grid">
            {JOB_DETAILS.benefits.map((item, i) => (
              <div key={i} className="work-list-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How to Apply */}
      <section className="section" style={{ background: 'var(--bg-dark)' }}>
        <div className="section-container" style={{ textAlign: 'center' }}>
          <span className="section-label">Apply Now</span>
          <h2 className="section-title">How to Apply</h2>
          <p className="section-subtitle" style={{ margin: '0 auto 20px' }}>
            Ready to build, learn, and ship real products? Send us your application.
          </p>
          <div className="apply-card">
            <p style={{ marginBottom: 12 }}>Send the following to <strong>{JOB_DETAILS.email}</strong>:</p>
            <ul className="apply-list">
              <li>Your resume or LinkedIn profile</li>
              <li>Short intro about yourself</li>
              <li>Any work samples (if available)</li>
            </ul>
            <p style={{ marginTop: 12, color: 'var(--text-secondary)' }}>
              Subject Line: <strong>Application for Intern / Tech & Operations Assistant</strong>
            </p>
            <a href={`mailto:${JOB_DETAILS.email}?subject=Application for Intern / Tech & Operations Assistant`} className="btn btn-primary" style={{ marginTop: 24 }}>
              Apply via Email
            </a>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section">
        <div className="section-container" style={{ textAlign: 'center' }}>
          <p className="section-subtitle" style={{ margin: '0 auto 20px' }}>
            Not the right fit? Explore other ways to work with us.
          </p>
          <Link to="/contact" className="btn btn-outline">Get in Touch</Link>
        </div>
      </section>
    </div>
  );
};

export default WorkWithUs;
